var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Loan Portfolio Aging"}},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.agingData,"fields":_vm.fields,"responsive":"sm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }